import { render, staticRenderFns } from "./NikudPaneContainer.vue?vue&type=template&id=146ca314&scoped=true&"
import script from "./NikudPaneContainer.vue?vue&type=script&lang=js&"
export * from "./NikudPaneContainer.vue?vue&type=script&lang=js&"
import style0 from "./NikudPaneContainer.vue?vue&type=style&index=0&id=146ca314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ca314",
  null
  
)

export default component.exports